import DiscoverNetworkView from './DiscoverNetworkView';
export default { DiscoverNetworkView };
